module.exports = __webpack_public_path__ + "static/img/icon-Exit-fullscreen.1de31c99.svg";